module.exports = __webpack_public_path__ + "static/sec6-bg-sm-65e586f9a7628f29e44da491dc05e6f3.jpg";